import React from 'react';
import StoreUtils from "../../services/Store/StoreUtils";
import HoursHelper from "../../services/Menu/services/Availability/HoursHelper";
import DateService from "../../services/Common/Date/DateService";
import {ConfigApi, ConfigHoursApi} from "../../services/Api/types";
import {useTranslation} from "react-i18next";

interface Props {
    config: ConfigApi
    openHours: ConfigHoursApi[] | undefined;
}

const TodayOpeningHours = ({config, openHours}: Props) => {
    const {t} = useTranslation();

    const drawContent = () => {
        if (StoreUtils.isPaused(config)) {
            return (
                <span className="text-warning">{t("common.word.temporarily_close")}</span>
            );
        }

        if (!openHours || openHours.length === 0) {
            return <span className="text-danger">{t("enums.store_status.closed")}</span>;
        }

        const mergedHours = HoursHelper.getMergedHourRanges(openHours);

        const isOpenNow = HoursHelper.isOpen(config.hours, DateService.now());

        if (!isOpenNow) {
            return mergedHours.map((h, index) => (
                <span
                    className="text-danger"
                    key={index + "-" + h.hour_from + "-" + h.hour_to}
                >
                    {h.hour_from === "00:00" && h.hour_to === "00:00"
                        ? `${t("enums.store_status.closed")} ${t("common.word.whole_day")}`
                        : `${t("enums.store_status.closed")} ${h.hour_from} - ${h.hour_to}`}
                </span>
            ));
        }

        return mergedHours.map((h, index) => (
            <span
                className="text-success"
                key={index + "-" + h.hour_from + "-" + h.hour_to}
            >
                {h.hour_from === "00:00" && h.hour_to === "00:00"
                    ? `${t("common.word.whole_day")}`
                    : `${h.hour_from} - ${h.hour_to}`}
            </span>
        ));
    }

    return (
        <span className="today-opening-hours">
            {drawContent()}
        </span>
    )
}

export default TodayOpeningHours;